/* eslint-disable */

import React, { useState } from "react";
import TablePaginate from "components/TablePaginate/TablePaginate";
import InputAdornment from "@material-ui/core/InputAdornment";
import Search from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core";
import CustomInput from "components/CustomInput/CustomInput";
import { puushdotPoolService } from "../../services/puushdotPoolService";
import ActionNormal from "./ActionNormal";
import Select from "components/Select/Select";
import { chainOptions } from "const";

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

export default function PuushdotPoolIndex() {
  const classes = useStyles();
  const [size] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [chainId, setChainId] = React.useState("-1");

  const getChainById = (id) => {
    const chain = chainOptions().find((c) => +c.value === +id);
    return chain ? chain.label : "Null";
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Collection ID",
        accessor: "collectionId",
      },
      // {
      //   Header: "Address",
      //   accessor: "address",
      // },
      // {
      //   Header: "Owner Address",
      //   accessor: "ownerAddress",
      // },
      {
        Header: "Chain ID",
        accessor: "chainId",
        Cell: function Tier(cell) {
          return getChainById(cell.value);
        },
      },
      // {
      //   Header: "Puush Fee Receiver",
      //   accessor: "puushFeeReceiver",
      // },
      {
        Header: "Puush Fee Amount",
        accessor: "puushFeeAmount",
      },

      {
        Header: "Action",
        Cell: function action({ cell }) {
          return (
            <>
              <ActionNormal
                item={cell.row.original}
                refresh={handleRefresh}
              ></ActionNormal>
            </>
          );
        },
      },
    ],
    []
  );

  const handleRefresh = () => {
    fetchPuushdot();
  };

  async function fetchPuushdot() {
    const payload = {
      search,
      page,
      size,
      sortBy: "order",
      sortType: "asc",
      chainId: +chainId,
    };
    if (!payload.chainId || payload.chainId === -1) delete payload.chainId;
    try {
      const { data } = await puushdotPoolService.list(payload);
      console.log({ data });
      setItems(data.items[0].items);
      setCount(+data.paginate.count);
      setPage(+data.paginate.page);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    fetchPuushdot();
  }, [page, search, chainId]);

  return (
    <div>
      {confirm}

      <div className={classes.filter}>
        <CustomInput
          labelText="Search"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Select
          label={"Chain"}
          value={chainId}
          onChange={setChainId}
          options={[{ value: "-1", label: "All" }, ...chainOptions()]}
        />

        {/* <Select
          value={type}
          onChange={(selected) => setType(selected)}
          label="Type"
          options={[
            { value: "", label: "All" },
            { value: "soft", label: "Soft" },
            { value: "normal", label: "Normal" },
          ]}
        /> */}
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}
